// src/pages/auth/WelcomeScreen.jsx
// ─────────────────────────────────────────────────────────────
// Shown when this device is not linked to any company.
// Offers two paths: Register (new company) or Login (existing company).
// ─────────────────────────────────────────────────────────────

import logo from "../../../assets/logo.png";

export default function WelcomeScreen({ onLogin, onRegister }) {
  return (
    <div className="auth-page">
      <div className="auth-card" style={{ maxWidth: 420 }}>

        {/* Logo */}
        <div className="auth-logo">
          <img src={logo} alt="" className="auth-logo-icon"/>
          <h1 className="auth-logo-title">Tailor Expert</h1>
          <p className="auth-logo-sub">Tailoring Order Management System</p>
        </div>

        {/* New device badge */}
        <div style={{
          background: "var(--blue-dim)",
          border: "1px solid rgba(90,154,224,0.25)",
          borderRadius: "var(--radius-sm)",
          padding: "10px 14px",
          marginBottom: 28,
          display: "flex", gap: 10, alignItems: "flex-start",
        }}>
          <span style={{ fontSize: 16, flexShrink: 0 }}>📱</span>
          <div>
            <div style={{ color: "var(--blue)", fontWeight: 700, fontSize: 13 }}>
              New Device
            </div>
            <div style={{ color: "var(--text-muted)", fontSize: 12, marginTop: 3 }}>
              This device is not linked to any shop yet. Choose an option below to continue.
            </div>
          </div>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>

          {/* Register button */}
          <button
            className="btn btn-primary btn-full btn-lg"
            onClick={onRegister}
          >
            🏪 Register New Shop
          </button>

          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div style={{ flex: 1, height: 1, background: "var(--border)" }} />
            <span style={{ fontSize: 12, color: "var(--text-dim)" }}>OR</span>
            <div style={{ flex: 1, height: 1, background: "var(--border)" }} />
          </div>

          {/* Login button */}
          <button
            className="btn btn-ghost btn-full btn-lg"
            onClick={onLogin}
          >
            🔑 Login to Existing Shop
          </button>
        </div>

        <p style={{
          textAlign: "center",
          marginTop: 24,
          fontSize: 11.5,
          color: "var(--text-dim)",
          lineHeight: 1.6,
        }}>
          Register to create a new shop account.<br />
          Login if your shop already exists on another device.
        </p>
      </div>
    </div>
  );
}
